import { IconButton, Tab, Tabs } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { RequestSnapshot } from './serviceRequestModel';

interface RequestTabsProps {
  requests: RequestSnapshot[];
  activeTab: number;
  disabled: boolean;
  onChange: (event: React.SyntheticEvent, value: number) => void;
  onRemove: (index: number) => void;
}

/** One tab per request with its status; a tab not yet submitted can be removed. */
export function RequestTabs({ requests, activeTab, disabled, onChange, onRemove }: RequestTabsProps) {
  return (
    <Tabs
      value={activeTab}
      onChange={disabled ? undefined : onChange}
      sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}>
      {requests.map((req, index) => (
        <Tab
          key={index}
          value={index}
          label={
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              Request {index + 1}
              {req.status === 'success' && <CheckCircleIcon sx={{ fontSize: 14, color: 'success.main' }} />}
              {req.status === 'failed' && <ErrorIcon sx={{ fontSize: 14, color: 'error.main' }} />}
              {req.status === 'pending' && requests.length > 1 && (
                <IconButton
                  size="small"
                  disabled={disabled}
                  aria-label={`Remove request ${index + 1}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onRemove(index);
                  }}
                  sx={{ ml: 0.5, p: 0, fontSize: '1rem', lineHeight: 1 }}>
                  ×
                </IconButton>
              )}
            </span>
          }
        />
      ))}
    </Tabs>
  );
}
